// extracted by mini-css-extract-plugin
export var black = "bib-search-module--black--74e13";
export var button = "bib-search-module--button--eeff6";
export var containerSearch = "bib-search-module--containerSearch--0240e";
export var form = "bib-search-module--form--601d7";
export var input = "bib-search-module--input--83977";
export var red = "bib-search-module--red--3294a";
export var root = "bib-search-module--root--70bd8";
export var secondButton = "bib-search-module--secondButton--1e0b6";
export var subtitle = "bib-search-module--subtitle--fc6e2";
export var title = "bib-search-module--title--5d4a4";
export var white = "bib-search-module--white--12267";